import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";
import { setUser } from "@sentry/react";
import { useMeta } from "../contexts/meta-context";
import { useHelpScout } from "../hooks/use-help-scout";

const IdentifyUser = () => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const { setHasUserAuthenticated } = useMeta();
  const posthog = usePostHog();
  const { identifyUser } = useHelpScout();

  useEffect(() => {
    if (authStatus !== "authenticated") {
      setUser(null);
      setHasUserAuthenticated(false);
      return;
    }

    let cancelled = false;

    const identify = async () => {
      try {
        const [currentUser, session] = await Promise.all([
          getCurrentUser(),
          fetchAuthSession(),
        ]);
        if (cancelled) return;

        const userId = currentUser.userId;
        const emailClaim = session.tokens?.idToken?.payload?.email;
        const email = typeof emailClaim === "string" ? emailClaim : undefined;

        setUser({
          id: userId,
          email: email?.toLowerCase(),
          ip_address: "{{auto}}",
        });

        if (posthog) {
          posthog.identify(userId, { user_type: "PATIENT" });
        }

        identifyUser({
          email,
          userId,
        });
      } catch {
        // best-effort analytics identify; auth session may race on boot
      }
    };

    identify();

    return () => {
      cancelled = true;
    };
  }, [authStatus, posthog, identifyUser, setHasUserAuthenticated]);

  return null;
};

export default IdentifyUser;
